import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AUTH } from "@/constants/appIds";
import { ReceiptText, Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) nav("/dashboard");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:flex flex-col justify-between p-12 bg-primary text-primary-foreground relative overflow-hidden">
        <div className="flex items-center gap-2">
          <ReceiptText className="w-7 h-7" />
          <span className="font-mono text-lg font-bold tracking-tight">Nota Harian</span>
        </div>
        <div className="relative z-10">
          <h1 className="text-4xl font-bold leading-tight tracking-tight">
            Foto nota,<br />AI membaca,<br />admin menyetujui.
          </h1>
          <p className="mt-4 text-primary-foreground/70 max-w-sm text-sm leading-relaxed">
            Catat belanja operasional F&B tanpa mengetik ulang. Setiap data diperiksa
            admin sebelum masuk ke Daily Report.
          </p>
        </div>
        <p className="text-xs text-primary-foreground/50 font-mono">Asia/Jakarta · Rupiah</p>
        <div className="absolute -right-20 -bottom-20 w-96 h-96 rounded-full border border-primary-foreground/10" />
        <div className="absolute right-10 bottom-10 w-64 h-64 rounded-full border border-primary-foreground/10" />
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="w-full max-w-sm nh-fade">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <ReceiptText className="w-6 h-6" />
            <span className="font-mono text-lg font-bold">Nota Harian</span>
          </div>
          <h2 className="text-2xl font-bold tracking-tight">Masuk</h2>
          <p className="text-sm text-muted-foreground mt-1 mb-6">
            Gunakan akun yang diberikan pemilik usaha.
          </p>

          {error && (
            <div data-testid={AUTH.error} className="mb-4 text-sm rounded-lg bg-red-50 text-red-700 border border-red-200 px-3 py-2">
              {error}
            </div>
          )}

          <div className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email}
                data-testid={AUTH.emailInput}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5" placeholder="nama@usaha.com" />
            </div>
            <div>
              <Label htmlFor="password">Kata Sandi</Label>
              <Input id="password" type="password" required value={password}
                data-testid={AUTH.passwordInput}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5" placeholder="••••••••" />
            </div>
          </div>

          <Button type="submit" disabled={loading} data-testid={AUTH.submitButton}
            className="w-full mt-6 rounded-full h-11">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Masuk"}
          </Button>

          <div className="mt-6 text-xs text-muted-foreground bg-secondary rounded-lg p-3 leading-relaxed">
            <p className="font-semibold mb-1">Akun demo:</p>
            <p>Admin — admin@notaharian.demo / admin123</p>
            <p>Pengunggah — staff@notaharian.demo / staff123</p>
          </div>
        </form>
      </div>
    </div>
  );
}
